import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyDocumentLang } from './i18n';
import { applyBackground, applyTheme, useUi } from './store/ui';
import { connectDesktopShell } from './lib/desktopGlue';
import { connectNotifications, startNotifyWiring } from './notify/wire';
import { setupHotkeys } from './voice/controller';
import { startSoundWiring } from './sound/wire';
import { startCallAlerts } from './store/calls';
import { wireConsoleDefaults } from './store/consoleDefaults';
import { watchLayout } from '@neosocial/ui/layout';
import { installLongPress } from '@neosocial/ui/touch';
import './styles/index.css';

applyDocumentLang();
applyBackground(useUi.getState().background);
applyTheme(useUi.getState().theme);
// a system theme change re-applies the meta colour
globalThis
  .matchMedia?.('(prefers-color-scheme: dark)')
  .addEventListener?.('change', () => applyTheme(useUi.getState().theme));

// phones and tablets (docs/design/visual-overhaul.md §12): data-layout, data-pointer and
// data-nav on <html> (Shell adds #nx-app), the visual viewport the keyboard leaves
// (--vv-h, --vv-top, --kb-h), and long-press as the touch screen's right-click
watchLayout();
installLongPress();

connectDesktopShell();
// OS notifications: the unread badge, toast clicks, seen conversations (notify/)
connectNotifications();
setupHotkeys();
// the console's defaults for whoever hasn't chosen (theme, voice mode)
wireConsoleDefaults();
// voice and alert sounds (synthesised; Settings > Sounds)
startSoundWiring();
// notification settings: the Console's flag, and timed mutes ending on time
startNotifyWiring();
// DM calls: the ring and its notification (2026-11-01)
startCallAlerts();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
